import { Dialog, Text, Box, Portal } from '@mantine/core'
import Link from 'next/link'
import React from 'react'
import { Button, BUTTON_SIZE, BUTTON_VARIANT } from 'components/Button'
import Icon, { ICON_SIZE } from 'components/Icon/Icon'
import { Flex } from 'components/Layout'
import { COLOR_INTENT, SPACE } from 'Theme'

export const AddToFavoritesDialog = ({
  isOpen,
  productTitle,
  isBookmarked,
  onClose,
  onUndo,
  favoritesDashboardUrl,
}: {
  isOpen: boolean
  productTitle: string
  isBookmarked: boolean
  onClose: () => void
  onUndo: (e: React.MouseEvent<HTMLButtonElement>) => void
  favoritesDashboardUrl: string
}) => (
  <Portal>
    <style>{`
      .mantine-Dialog-modal {
        transform: translateX(-50%) !important;
      }
    `}</style>
    <Dialog
      opened={isOpen}
      onClose={onClose}
      position={{ bottom: 20, left: '50%' }}
      size="md"
      radius="md"
      shadow="0px 0px 0px 0px rgba(0, 0, 0, 0.02)"
      withBorder
      miw={{ base: 320, sm: 700 }}
      className="mantine-Dialog-modal"
      styles={{
        root: {
          padding: 24,
          borderRadius: 10,
        },
      }}
    >
      <Flex
        justifyContent="space-between"
        flexDirection={{ MOBILE: 'column', TABLET: 'row' }}
        gap={SPACE.PX_10}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}
        position="relative"
      >
        <Box
          pos="absolute"
          top="-10px"
          right="-10px"
          miw={SPACE.PX_24}
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            onClose()
          }}
        >
          <Icon.Cross size={ICON_SIZE.PX_24} />
        </Box>
        <Flex alignItems="center">
          <Box miw={SPACE.PX_24}>
            {isBookmarked ? (
              <Box onClick={onClose}>
                <Icon.Checkmark size={ICON_SIZE.PX_24} />
              </Box>
            ) : (
              <Box onClick={onClose}>
                <Icon.Cross size={ICON_SIZE.PX_24} />
              </Box>
            )}
          </Box>
          <Text size="md" ml={SPACE.PX_8} c={COLOR_INTENT.GRAY_90}>
            <Text span c={COLOR_INTENT.TEXT_ON_LIGHT} fw={500} inherit>
              {productTitle}
            </Text>
            {isBookmarked
              ? ' has been added to Favorites.'
              : ' has been removed from Favorites.'}
          </Text>
        </Flex>
        <Flex alignItems="center" gap={SPACE.PX_16} mx={SPACE.PX_20}>
          <Button
            width="100%"
            variant={BUTTON_VARIANT.DEFAULT}
            size={BUTTON_SIZE.L}
            aria-label="Undo favorite"
            onClick={onUndo}
          >
            Undo
          </Button>

          <Link href={favoritesDashboardUrl} passHref>
            <Button
              as="a"
              width="100%"
              variant={BUTTON_VARIANT.OUTLINE}
              size={BUTTON_SIZE.L}
              aria-label="View Favorites"
            >
              View Favorites
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Dialog>
  </Portal>
)
